import { observer } from 'mobx-react-lite'
import { Icon, SpinnerLoader, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useSavedRepliesContext } from 'widgets/SavedReplies/context'
import { SavedReplySelectedItem } from './SavedReplySelectedItem/SavedReplySelectedItem'
import styles from './styles.module.scss'

export const RightContent = observer(() => {
  const { selectedSavedReply, loading } = useSavedRepliesContext()
  const { mergeFieldStore } = useEntitiesContext()

  if (mergeFieldStore.loading) {
    return (
      <div className={styles.empty}>
        <SpinnerLoader ariaLabel={'SavedRepliesRightContent'} size={24} />
      </div>
    )
  }

  return selectedSavedReply ? (
    <SavedReplySelectedItem />
  ) : (
    <div className={styles.empty}>
      {loading ? (
        <SpinnerLoader ariaLabel={'SavedRepliesRightContent'} size={24} />
      ) : (
        <div className={styles.emptyTitle}>
          <Icon icon={'savedReplies'} fontSize={24} color={'var(--content-primary-tertiary)'} />
          <Typography
            variant={'body-md-medium'}
            color={'var(--content-primary-tertiary)'}
            ariaLabel={'The preview'}
          >
            The preview will show up here
          </Typography>
        </div>
      )}
    </div>
  )
})
